import { SharingData } from '../../schema/SharingData';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export function cannotShareExternally(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    const hasExternalRecipients =
        recipientInfo.filter(recipient => {
            return recipient.externalMemberCount > 0;
        }).length > 0;
    return (
        hasExternalRecipients &&
        sharingData.sharingInfo &&
        !sharingData.sharingInfo.canShareExternally &&
        (sharingData.currentPermissionLevel === AttachmentPermissionLevel.Edit ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.View)
    );
}
